export const DEFAULT_BOX_SIZE = 0.08;
export const DRAG_THRESHOLD = 6;
export const EDGE_HIT_DISTANCE = 8;
export const EDITOR_LINE_WIDTH = 2;
export const ARROW_LENGTH = 14;
export const ARROW_WIDTH = 10;
export const SELECTION_ARROW_BOB_SPEED = 2.2;
export const SELECTION_ARROW_BOB_HEIGHT = 0.14;
export const SELECTION_ARROW_OFFSET = 0.18;
export const SELECTION_ARROW_SCALE = 1.3;
export const SELECTION_PROMPT_HEIGHT = 0.06;
export const SELECTION_PROMPT_TEXT_HEIGHT = 0.9;

export const CHARACTER_SCALE = 1.25;
export const CHARACTER_JUMP_HEIGHT = 0.6;
export const ENTRY_JUMP_HEIGHT = 2.25;
export const CHARACTER_STEP_DURATION = 0.266;
export const CHARACTER_BASE_OFFSET = 0.18;
export const CHARACTER_SPAWN_HEIGHT = 1.2;
export const CHARACTER_SPAWN_DURATION = 0.5;
export const CHARACTER_SPAWN_MIN_DURATION = 0.4;
export const CHARACTER_SPAWN_MAX_DURATION = 0.9;
export const CHARACTER_SPAWN_DELAY = 0;
export const KNIGHT_VARIANT = "female";
export const ACTIVE_CHARACTER_ID = "future_princess";
export const ACTIVE_MONSTER_ID = "demon_warrior";
export const ROSTER_SCALE = 1;
export const ROSTER_WOBBLE_SPEED = 2.4;
export const ROSTER_SPAWN_MIN_DURATION = 0.35;
export const ROSTER_SPAWN_MAX_DURATION = 0.85;
export const ROSTER_SPAWN_STAGGER = 0.1;
export const ROSTER_PLAYER_OFFSETS = [
  { x: -0.9, y: 0.35 },
  { x: -0.75, y: -0.05 },
  { x: -0.62, y: -0.4 },
  { x: -0.95, y: 0.05 },
];
export const ROSTER_MONSTER_OFFSETS = [
  { x: 0.9, y: 0.35 },
  { x: 0.75, y: -0.05 },
  { x: 0.62, y: -0.4 },
  { x: 0.95, y: 0.05 },
];

export const YUT_ANIM_COLS = 4;
export const YUT_ANIM_ROWS = 3;
export const YUT_ANIM_FRAMES = 12;
export const YUT_ANIM_FPS = 15;
export const YUT_ANIM_HEIGHT = 0.64;
export const YUT_THROW_TOTAL = 5;
export const YUT_BUTTON_ASPECT = 448 / 214;
export const YUT_BUTTON_WIDTH_RATIO = 0.221;
export const YUT_BUTTON_MARGIN_X = 0.02;
export const YUT_BUTTON_MARGIN_Y = 0.06;
export const YUT_BUTTON_DROP_DURATION = 0.6;
export const YUT_BUTTON_TITLE_Y = 0.62;
export const YUT_BUTTON_TITLE_HEIGHT = 0.24;
export const YUT_BUTTON_COUNT_Y = 0.68;
export const AUTO_TOGGLE_WIDTH_RATIO = 0.48;
export const AUTO_TOGGLE_HEIGHT_RATIO = 0.3;
export const AUTO_TOGGLE_GAP_RATIO = 0.18;
export const YUT_RESULT_DURATION = 0.35;
export const YUT_RESULT_HOLD = 2.0;
export const YUT_RESULT_FADE = 0.4;
export const YUT_RESULT_HEIGHT = 0.22;
export const YUT_RESULT_OFFSET_Y = 0.34;
export const ONE_MORE_DURATION = 0.35;
export const ONE_MORE_HOLD = 0.8;
export const ONE_MORE_FADE = 0.4;
export const ONE_MORE_HEIGHT = 0.2;
export const ONE_MORE_DELAY = 1.0;
export const ONE_MORE_TOTAL = ONE_MORE_DURATION + ONE_MORE_HOLD + ONE_MORE_FADE;
export const MONSTER_THROW_DELAY = 1.0;
export const FINISH_JUMP_COUNT = 3;
export const FINISH_JUMP_DURATION = 0.35;
export const FINISH_TO_GOAL_DURATION = 0.6;
export const FINISH_TO_GOAL_STAGGER = 0.5;
export const FINISH_TO_GOAL_JUMP_HEIGHT = 1.1;
export const ENTRY_DROP_HEIGHT = 1.2;
export const WAITING_MOVE_SPEED = 10;

export const appState = {
  requestDraw: null,
  onEconomySync: null,
  onYutHold: null,
  onAtlasReady: null,
};

export const runtimeState = {
  unity: null,
  sessionKey: null,
  useStub: false,
  debugAllowed: false,
  clientApiDebug: false,
  sessionId: null,
  actionBusy: false,
  currentPrompt: null,
};

export const textures = {
  atlas: createEmptySprite(),
  background: createEmptySprite(),
  backgroundSize: { width: 1, height: 1 },
  board: createEmptySprite(),
  boardSize: { width: 1, height: 1 },
};

export const titleSprite = createEmptySprite();
export const titleHelpSprite = createEmptySprite();
export const loadingSpinner = createEmptySprite();
export const luckyBagSprite = createEmptySprite();
export const luckyBagBlueSprite = createEmptySprite();
export const giftIconSprite = createEmptySprite();
export const blueGiftIconSprite = createEmptySprite();
export const missionButtonSprite = createEmptySprite();
export const rewardBackgroundSprite = createEmptySprite();
export const rewardWinSprite = createEmptySprite();
export const rewardLoseSprite = createEmptySprite();

export const seasonPanelLabel = Object.assign(createEmptySprite(), {
  width: 360,
  height: 120,
  canvas: null,
  ctx: null,
});

export const luckyPanelLabel = Object.assign(createEmptySprite(), {
  width: 320,
  height: 100,
  canvas: null,
  ctx: null,
});
export const bluePanelLabel = Object.assign(createEmptySprite(), {
  width: 320,
  height: 100,
  canvas: null,
  ctx: null,
});
export const oneMoreSprites = {
  one: createEmptySprite(),
  two: createEmptySprite(),
  three: createEmptySprite(),
  four: createEmptySprite(),
};

export const boardAnim = {
  active: false,
  initialized: false,
  y: 0,
  vy: 0,
  targetY: 0,
};

export const editor = {
  enabled: false,
  boxes: [],
  edges: [],
  selectedBoxId: null,
  selectedEdgeId: null,
  startBoxId: null,
  pendingClick: null,
  dragMode: null,
  dragBoxId: null,
  dragOffset: { x: 0, y: 0 },
  linkFromId: null,
  linkPreviewPos: null,
  lastClickTime: 0,
  lastClickBoxId: null,
  nextBoxId: 1,
};

export const rosterState = {
  time: 0,
  tokens: [],
  spawnPending: false,
  spawnUseState: false,
  waitingSignature: "",
};

const createYutFrames = () => Array.from({ length: 12 }, () => createEmptySprite());

export const yutSprites = {
  throwFrames: createYutFrames(),
  results: [
    {
      key: "do",
      weight: 15.4,
      steps: 1,
      frames: createYutFrames(),
      frameKey: "B1_Do",
    },
    {
      key: "gae",
      weight: 34.6,
      steps: 2,
      frames: createYutFrames(),
      frameKey: "B2_Gae",
    },
    {
      key: "geol",
      weight: 34.6,
      steps: 3,
      frames: createYutFrames(),
      frameKey: "B3_Geol",
    },
    {
      key: "yut",
      weight: 13.0,
      steps: 4,
      frames: createYutFrames(),
      frameKey: "B4_Yut",
    },
    {
      key: "mo",
      weight: 2.4,
      steps: 5,
      frames: createYutFrames(),
      frameKey: "B5_Mo",
    },
  ],
};

export const yutProbabilities = {
  player: {},
  monster: {},
};

export const yutResultSprites = {
  do: createEmptySprite(),
  gae: createEmptySprite(),
  geol: createEmptySprite(),
  yut: createEmptySprite(),
  mo: createEmptySprite(),
};

export const yutAnim = {
  state: "idle",
  frame: 0,
  elapsed: 0,
  frames: null,
  resultSteps: 0,
  resultKey: null,
  owner: "player",
  moveQueued: false,
  scoreAwarded: false,
};

export const yutResultOverlay = {
  sprite: null,
  active: false,
  elapsed: 0,
  holdElapsed: 0,
};

export const oneMoreOverlay = {
  active: false,
  elapsed: 0,
  holdElapsed: 0,
  team: null,
  variant: 1,
};

export const yutButtonTexture = createEmptySprite();
export const yutButtonGlowSprite = createEmptySprite();
export const yutButtonTitleSprite = createEmptySprite();
export const yutButtonIconSprite = createEmptySprite();

export const autoToggleLabel = {
  texture: null,
  width: 220,
  height: 70,
  canvas: null,
  ctx: null,
};

export const yutButtonLabel = {
  texture: null,
  width: 448,
  height: 214,
  canvas: null,
  ctx: null,
  countBox: null,
  countIcon: null,
};

export const turnBannerSprites = {
  player: createEmptySprite(),
  monster: createEmptySprite(),
};

export const selectionArrowSprite = createEmptySprite();
export const selectionAuraSprite = createEmptySprite();
export const selectionRingSprite = createEmptySprite();

export const selectionPromptSprite = createEmptySprite();
export const selectionPromptLabel = Object.assign(createEmptySprite(), {
  width: 640,
  height: 128,
  canvas: null,
  ctx: null,
});

export const turnBanner = {
  active: false,
  elapsed: 0,
  holdElapsed: 0,
  team: "player",
};

export const winOverlay = {
  active: false,
  elapsed: 0,
  textElapsed: 0,
  floatTime: 0,
  team: null,
};

export const yutButtonAnim = {
  active: false,
  progress: 0,
  duration: YUT_BUTTON_DROP_DURATION,
  pending: true,
};

export const turnState = {
  current: "player",
  awaitingMonster: false,
  monsterDelayRemaining: 0,
  bonusThrowCount: {
    player: 0,
    monster: 0,
  },
  bonusThrowStreak: {
    player: 0,
    monster: 0,
  },
  freeThrowFor: null,
};

export const moveState = {
  active: false,
  team: null,
  pieces: [],
  path: [],
  stepIndex: 0,
  progress: 0,
  from: null,
  to: null,
  stepDuration: CHARACTER_STEP_DURATION,
};

export const selectionState = {
  active: false,
  steps: 0,
  groups: [],
};

export const branchState = {
  active: false,
  team: null,
  steps: 0,
  group: null,
  fromBoxId: null,
  candidates: [],
  choices: [],
};

export const gameState = {
  playerTurnCount: 0,
  winner: null,
  score: 0,
  blueScore: 0,
  goalCounts: {
    player: 0,
    monster: 0,
  },
};

export const shakeState = {
  active: false,
  elapsed: 0,
  duration: 0.25,
  strength: 8,
};

export const separationState = {
  animating: false,
  activePlayerX: 0,
  activeMonsterX: 0,
  activeMonsterY: 0,
  targetPlayerX: 0,
  targetMonsterX: 0,
  targetMonsterY: 0,
};

export const yutThrowState = {
  used: 0,
  total: YUT_THROW_TOTAL,
};

export const autoPlayState = {
  enabled: false,
};

export const languageState = {
  current: "ko",
};

export const seasonState = {
  ended: false,
};

export const debugOptions = {
  dragPieces: false,
  fixedYut: false,
  forcedYutKey: null,
};

export const restartConfig = {
  bonusThrows: 5,
};

export const scoreEvents = [];
export const scoreBags = [];
export const scoreBursts = [];

export const SCORE_BAG_MAX = 8;
export const SCORE_BAG_SIZE = 0.055;
export const SCORE_BAG_BURST_DURATION = 0.18;
export const SCORE_BAG_FLY_DURATION = 0.65;

export const scoreConfig = {
  yut: 150,
  mo: 150,
  do: 150,
  gae: 150,
  geol: 150,
  capture: 1000,
  goal: 500,
  goal2: 2000,
  goal3: 5000,
  goal4: 10000,
  blueGoal: 30,
  blueGoal2: 75,
  blueGoal3: 150,
  blueGoal4: 200,
  win: 10000,
};

export function createEmptySprite(options = null) {
  return {
    texture: null,
    width: 0,
    height: 0,
    frameWidth: options?.frameWidth || 0,
    frameHeight: options?.frameHeight || 0,
    uv: null,
    sourceWidth: 0,
    sourceHeight: 0,
    trimX: 0,
    trimY: 0,
    trimWidth: 0,
    trimHeight: 0,
    trimmed: false,
  };
}

export function initRosterTokens() {
  const knightBase = KNIGHT_VARIANT === "male" ? "knight_male" : "knight_female";
  const rosterEntries = [
    {
      id: "future_princess",
      team: "player",
      idlePath: "assets/image/characters/future_princess_idle.png",
      jumpPath: "assets/image/characters/future_princess_jump.png",
    },
    {
      id: "knight_captain",
      team: "player",
      idlePath: "assets/image/characters/knight_captain_idle.png",
      jumpPath: "assets/image/characters/knight_captain_jump.png",
    },
    {
      id: knightBase,
      team: "player",
      idlePath: `assets/image/characters/${knightBase}_idle.png`,
      jumpPath: `assets/image/characters/${knightBase}_jump.png`,
    },
    {
      id: "maiden",
      team: "player",
      idlePath: "assets/image/characters/maiden_idle.png",
      jumpPath: "assets/image/characters/maiden_jump.png",
    },
    {
      id: "demon_warrior",
      team: "monster",
      idlePath: "assets/image/characters/demon_warrior.png",
    },
    {
      id: "hulk_demon",
      team: "monster",
      idlePath: "assets/image/characters/hulk_demon.png",
    },
    {
      id: "invader_archer",
      team: "monster",
      idlePath: "assets/image/characters/invader_archer.png",
    },
    {
      id: "invader_soldier",
      team: "monster",
      idlePath: "assets/image/characters/invader_soldier.png",
    },
  ];

  let playerIndex = 0;
  let monsterIndex = 0;
  rosterState.tokens = rosterEntries.map((entry, index) => {
    const isPlayer = entry.team === "player";
    const slotIndex = isPlayer ? playerIndex++ : monsterIndex++;
    const offsets = isPlayer ? ROSTER_PLAYER_OFFSETS : ROSTER_MONSTER_OFFSETS;
    const baseOffset = offsets[slotIndex % offsets.length];
    const jitter = {
      x: Math.cos(index * 1.7) * 0.04,
      y: Math.sin(index * 1.3) * 0.04,
    };
    return {
      id: entry.id,
      team: entry.team,
      order: index,
      idle: createEmptySprite(),
      jump: createEmptySprite(),
      idlePath: entry.idlePath,
      jumpPath: entry.jumpPath || null,
      ready: false,
      facing: isPlayer ? 1 : -1,
      phase: index * 0.65,
      offset: {
        x: baseOffset.x + jitter.x,
        y: baseOffset.y + jitter.y,
      },
      status:
        entry.id === ACTIVE_CHARACTER_ID || entry.id === ACTIVE_MONSTER_ID ? "active" : "waiting",
      boxId: null,
      hasLeftStart: false,
      idleTime: 0,
      spawnActive: false,
      spawnProgress: 0,
      spawnDuration: 0.6,
      spawnDelayRemaining: 0,
      spawnFrom: null,
      spawnTo: null,
      entryActive: false,
      entryProgress: 0,
      entryDuration: 0.6,
      entryFrom: null,
      entryTo: null,
      knockActive: false,
      knockProgress: 0,
      knockDuration: 0.7,
      knockFrom: null,
      knockTo: null,
      knockSpin: 0,
      knockImpact: false,
      finishActive: false,
      finishPhase: "celebrate",
      finishProgress: 0,
      finishJumpCount: 0,
      finishFrom: null,
      finishTo: null,
      finishDelayRemaining: 0,
      goalIndex: null,
      waitingPos: null,
      separationX: 0,
      separationTargetX: 0,
    };
  });
}
